import React, { useState, useEffect } from "react";
import validator from 'validator';
import { useSelector, useDispatch } from "react-redux"
import { selectUser } from 'src/stores/userSlice';
import { fetchAllEmployees } from 'src/stores/employeeSlice';
import moment from "moment";
import { notify } from "../utils/ToastUtils";
import { CircleAlert } from 'lucide-react';
import ApiClient from '../ApiClient';
import SharedProfileForm from './SharedProfileForm';

function IndiaUpdateUser(props) {
    const dispatch = useDispatch();
    const initialState = {
        firstName: '',
        lastName: '',
        fatherName: '',
        phone: '',
        bloodGrp: '',
        dob: '',
        originalDob: '',
        addrLine1: '',
        addrLine2: '',
        city: '',
        empstate: '',
        pincode: '',
        email: '',
        contactNo: '',
        aadharNo: '',
        panNo: '',
        nameAsBank: '',
        bank: '',
        accountNo: '',
        ifsc: '',
        uanPF: '',
        manager: '',
        status: '',
        designation: '',
        doj: '',
        dataAcesMail: '',
        location: '',
        role: '',
    };
    const [state, setState] = useState(initialState);
    const [remote, setRemote] = useState("No");
    const [checked, setChecked] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [submitAttempted, setSubmitAttempted] = useState(false);
    const user = useSelector(selectUser);

    const handleCheckBoxChange = (event) => {
        setChecked(event.target.checked);
    };

    function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
        if (evt.target.name === "email") {
            if (validator.isEmail(value)) {
                setEmailError('Valid');
            } else {
                setEmailError('Enter valid Email!');
            }
        }
        if (evt.target.name === "remote") {
            setRemote(evt.target.value);
        }
    }

    const resetForm = () => {
        setSubmitAttempted(false);
        setState(initialState);
        setChecked(false);
        setRemote(props.data?.REMOTE_EMPLOYEE || "No");
        setState({
            firstName: (props.data?.EMP_NAME)?.split(' ')[0] || '',
            lastName: (props.data?.EMP_NAME)?.substr(props.data?.EMP_NAME.indexOf(" ") + 1) || '',
            fatherName: props.data?.EMP_FATHERS_NAME || '',
            phone: props.data?.EMP_MOBILE_NO || '',
            bloodGrp: props.data?.EMP_BLOOD_GROUP || '',
            dob: props.data?.EMP_DATE_OF_BIRTH ? moment(props.data?.EMP_DATE_OF_BIRTH).format("YYYY-MM-DD") : '',
            originalDob: props.data?.ORIGINAL_DOB ? moment(props.data?.ORIGINAL_DOB).format("YYYY-MM-DD") : "",
            doj: props.data?.EMP_DATE_OF_JOIN ? moment(props.data?.EMP_DATE_OF_JOIN).format("YYYY-MM-DD") : '',
            addrLine1: props.data?.EMP_ADDRESS_1 || '',
            addrLine2: props.data?.EMP_ADDRESS_2 || '',
            city: props.data?.EMP_CITY || '',
            empstate: props.data?.EMP_STATE || '',
            pincode: props.data?.PINCODE || '',
            location: props.data?.EMP_LOCATION || '',
            dataAcesMail: props.data?.EMP_WORK_EMAIL || '',
            email: props.data?.EMP_PERSONAL_EMAIL || '',
            contactNo: props.data?.EMERGENCY_CONTACT_NO || '',
            aadharNo: props.data?.EMP_AADHAR_NO || '',
            panNo: props.data?.EMP_PAN_NO || '',
            nameAsBank: props.data?.EMP_NAME_AS_IN_BANK || '',
            bank: props.data?.EMP_BANK_NAME || '',
            accountNo: props.data?.EMP_ACCOUNT_NO || '',
            ifsc: props.data?.EMP_IFSC_NO || '',
            uanPF: props.data?.EMP_PF_NO || '',
            status: props.data?.STATUS || '',
            designation: props.data?.DESIGNATION || '',
            manager: props.data?.REPORTING_MANAGER_ID || '',
            role: props.data?.ROLE || '',
        });
    };

    useEffect(() => {
        resetForm();
    }, [props.data]);

    const updateProfile = async () => {
        setSubmitAttempted(true);
        if (state.firstName && state.lastName && state.fatherName && state.phone && state.bloodGrp && state.dob && state.email && state.contactNo && state.addrLine1 && state.addrLine2 && state.city && state.pincode && state.aadharNo && state.panNo && state.nameAsBank && state.bank && state.accountNo && state.ifsc && state.uanPF && remote) {
            if (checked === true) {
                try {
                    await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/user/updateBio`, {
                        empcode: props.data.EMP_CODE,
                        empName: state.firstName + " " + state.lastName,
                        fatherName: state.fatherName,
                        phone: state.phone,
                        bloodGrp: state.bloodGrp,
                        dob: state.dob,
                        originalDob: state.originalDob,
                        email: state.email,
                        contactNo: state.contactNo,
                        addrLine1: state.addrLine1,
                        addrLine2: state.addrLine2,
                        city: state.city,
                        empstate: state.empstate,
                        pincode: state.pincode,
                        aadharNo: state.aadharNo,
                        panNo: state.panNo,
                        nameAsBank: state.nameAsBank,
                        bank: state.bank,
                        accountNo: state.accountNo,
                        ifsc: state.ifsc,
                        uanPF: state.uanPF,
                        remote,
                        lastUpdatedDt: moment(new Date()).format("YYYY-MM-DD"),
                        isManager: user?.is_admin,
                    });
                    notify.success("Profile updated successfully");
                    dispatch(fetchAllEmployees());
                } catch (error) {
                    let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later";
                    notify.error(errmsg);
                }
            }
        }
    };

    return (
        <SharedProfileForm 
            isUS={false}
            submitAttempted={submitAttempted}
            showValidationBanner={submitAttempted && (!(state.firstName && state.lastName && state.fatherName && state.phone && state.bloodGrp && state.dob && state.email && state.contactNo && state.addrLine1 && state.addrLine2 && state.city && state.pincode && state.aadharNo && state.panNo && state.nameAsBank && state.bank && state.accountNo && state.ifsc && state.uanPF && remote) || !checked)}
            state={{...state, remote}}
            handleChange={(evt) => {
                if (evt.target.name === 'remote') setRemote(evt.target.value);
                else handleChange(evt);
            }}
            handleCheckBoxChange={handleCheckBoxChange}
            checked={checked}
            updateProfile={updateProfile}
            handleCancel={resetForm}
            editable={false}
            emailError={emailError}
            isLoading={false}
            userSummary={{
                avatar: props.data?.IMG_PATH ? `${process.env.REACT_APP_PUBLIC_URL}/${props.data?.IMG_PATH}` : null,
                name: state.firstName + " " + state.lastName,
                designation: state.designation,
                empId: props.data?.EMP_CODE,
                department: props.data?.DEPARTMENT || 'Engineering',
                status: state.status,
                doj: state.doj ? moment(state.doj).format("DD MMM YYYY") : "-",
                manager: state.manager,
                workEmail: state.dataAcesMail
            }}
            onUploadImage={null}
        />
    );
}

export default IndiaUpdateUser;